module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', [_c('p', {
    staticClass: "dedication",
    attrs: {
      "lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "Italic-Style",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("For our daughter, Melissa\tv")])]), _vm._v(" "), _c('p', {
    staticClass: "dedication",
    attrs: {
      "lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "Italic-Style",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("who has Nanny’s eyes\tv")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5974c9da","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/97815040844061.vue
// module id = 69
// module chunks = 0